<template>
    <div class="flex w-100">
        <div class="flex w-100 center-xs middle-xs">
            <div class="flex mt-30 col middle-xs" :class="isMobileView ? 'w-90' : 'w-40'">
                <div class="flex head pl-10 pr-10 mb-30">UPDATE TEST</div>
                <div class="flex w-100 mt-5 mb-5">
                    <input class="w-100 pt-15 pb-15 pl-20 inputEle" type="text" placeholder="Test Name" v-model="data.name" @focusout="data.isInvalidName = data.name == ''">
                    <div  v-if="data.isInvalidName" class="error mb-5 p-5">Test name is required</div>
                </div>

                <!-- type prop from Test Model completely removed so commenting 'type' related code
                <div class="flex w-100 mb-5">
                    <div class="mt-10">Test type: </div>
                    <div class="ml-10 mt-5 pl-10 pr-10 pt-5 pb-5 btn" :class="data.type == 'performance' ? 'buttonC' : 'button'" @click="data.type = 'performance'">Performance</div>
                    <div class="ml-10 mt-5 pl-10 pr-10 pt-5 pb-5 btn" :class="data.type == 'feature' ? 'buttonC' : 'button'" @click="data.type = 'feature'">Feature</div>
                </div>
                <div  v-if="data.isInvalidType" class="error mb-5 p-5">Test type is required</div>
                -->

                <div class="flex w-100 mt-5 mb-5">
                    <input class="w-100 pt-15 pb-15 pl-20 inputEle" type="text" placeholder="Description" v-model="data.info">
                </div>
                <div class="flex w-100 mt-5 mb-5">
                    <Multiselect class="w-100 pt-15 pb-15 pl-20" v-model="data.resultTypes" placeholder="Select result types" mode="tags" :close-on-select="false" :searchable="true" :options="data.resultTypeData" @focusout="data.isInvalidResultType = !data.resultTypes.length" />
                    <div  v-if="data.isInvalidResultType" class="error mb-5 p-5">Atleast one result type is required</div>
                </div>
                <div class="flex w-100 mt-5 mb-5">
                    <van-checkbox v-model="data.isPublic" checked-color="#0fab61" icon-size="30px">Public Test</van-checkbox>
                </div>
                <div class="flex w-100">
                    <image-uploader @image-loaded="onImageLoaded"></image-uploader>
                    <div  v-if="data.isInvalidImage" class="error mb-5 p-5">Image upload failed, Please upload again !</div>
                </div>
                <div  v-if="data.isUpdationFailed" class="error mb-5 p-5">Collection updation failed, Please try agian !</div>
                <div class="flex w-100 mt-30">
                    <div class="w-40 pt-15 pb-15 buttonC" :class="isMobileView ? 'pl-10 pr-10' : 'pl-15 pr-10'" @click="navigateBack()">Back</div>
                    <div class="w-40 pt-15 pb-15 buttonC buttonR" :class="isMobileView ? 'pl-10 pr-10' : 'pl-15 pr-10'" @click="updateTest()">Update</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { isMobile } from "@/lib/utils"
import { computed, reactive, onBeforeMount } from 'vue'
import router from "@/lib/router.js"
import { get, put, post } from "@/lib/api.js"
import Multiselect from '@vueform/multiselect'
import { useRoute } from "vue-router";
import ImageUploader from "../../components/ImageUploader.vue"

const route = useRoute()
const data = reactive({
    isInvalidName: false,
    //isInvalidType: false,
    isInvalidResultType: false,
    isInvalidImage: false,
    isUpdationFailed: false,
    image: '',
    name: '',
    //type: '',
    info: '',
    resultTypes: [],
    resultTypeData: ['capability'],
    isPublic: false,

    isInvalidData: function() {
        //this.isInvalidType = this.type == ''
        this.isInvalidName = this.name == ''
        this.isInvalidResultType = !this.resultTypes.length
        return (this.isInvalidName || this.isInvalidResultType || this.isInvalidImage)
    }
})
const isMobileView = computed(() => {
    return isMobile()
})
let imageObj;
function onImageLoaded(image){
    imageObj = image;
}
function navigateBack() {
    router.push({path: '/collections'})
}
async function updateTest() {
    if (data.isInvalidData()) {
        return
    }
    try {
        // upload image
        if(imageObj) {
            const imageRes = await post('users/me/images/test', true, imageObj);
            data.image = imageRes.data.imagePath
        } else {
            delete data.image
        }

        // update test
        const test = await put(`users/me/tests/${route.params.id}`, true, data);
        if(test.status == "success") {
            router.push({path: '/collections'})
        }
    } catch (error) {
        if(['imageUploadFailed','invalidImageType'].includes(error.response.data.message)) {
            data.isInvalidImage = true
        } else {
            data.isUpdationFailed = true
        }
        console.error('error updating test:', error);
    }
}
onBeforeMount(async() => {
    try {
        const res = await get(`users/me/tests/${route.params.id}`, true)
        data.name = res.data.name
        data.info = res.data.info
        //data.type = res.data.type
        data.resultTypes = res.data.resultTypes
        data.isPublic = res.data.isPublic
    }
    catch(error) {
        console.error("dataFetchError : " + error)
    }
})
</script>
<style lang="scss" scoped>
.buttonC {
    border-radius: 10px;
}
.button {
    border: 1px solid gray;
    border-radius: 10px;
}
.head {
    font-family: Bold;
    font-size: 20px;
    color: #000;
}
.buttonR {
    margin-left: 20%;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>
